import { TransportOrderIdView } from '../../../../models';

export class ShipmentTransportOrderLoadsLoad {
  public static readonly type = '[ShipmentTransportOrderLoads] Load';
  constructor(public payload: TransportOrderIdView) {}
}

export class ShipmentTransportOrderLoadsInitialState {
  public static readonly type = '[ShipmentTransportOrderLoads] Set Initial State';
}
